import React from "react";
import { connect } from "react-redux";
import headerGraphic from "../../../assets/images/error-illustration.svg";
import { clearError } from "../../../state/mode/mode.actions";
import { Localized } from "../../../strings";
import { ErrorDialogWithImage } from "./ErrorDialogWithImage";

const mapDispatchToProps = {
  clearError,
};

type OrgBlockedCreateDialogProps = typeof mapDispatchToProps;

export const OrgBlockedCreateDialog: React.FC<OrgBlockedCreateDialogProps> = ({
  clearError,
}) => {
  const strings = Localized.object("ORG_BLOCKED_CREATE_DIALOG");

  return (
    <ErrorDialogWithImage
      imageUrl={headerGraphic}
      onCancel={clearError}
      text={strings.TEXT}
      title={strings.TITLE}
    />
  );
};

export default connect(undefined, mapDispatchToProps)(OrgBlockedCreateDialog);
